// Test IDs for the home / landing feature. Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const HOME = {
  landing: "home-landing",
  landingHint: "home-landing-hint",
};
